import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col, DropdownItem } from 'reactstrap'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import moment from '../../../lib/moment.js'
import metrolendarHelper from '../helper'
import Group from '../group'
import { FONTS } from '../../../constants'
import ArrowUp from '../../../static/images/arrow-up-black.svg'
import ArrowDown from '../../../static/images/arrow-down-black.svg'

export default class VerticalTableCalendar extends React.Component {
  onGroupHeaderClick(group) {
    this.setState((state, prop) => ({
      [group.id]: !(state && state[group.id]),
    }))
  }
  isPublicHoliday(date) {
    const publicHolidays = this.props.publicHolidays
    let holiday = { holiday: null, isHoliday: false }
    if (publicHolidays !== undefined) {
      for (let i = 0; i < publicHolidays.length; i++) {
        if (moment(date).isSame(moment(publicHolidays[i].date), 'day')) {
          holiday = { holiday: publicHolidays[i], isHoliday: true }
          break
        }
      }
    }
    return holiday
  }
  renderGroup(group, i, dates) {
    return (
      <div style={ { flex: '0 0 auto', display: 'flex', flexDirection: 'column' } } key={ i }>
        {this.renderGroupHeaderRow(group, i, dates)}
        <div style={ { display: (this.state && !this.state[group.id]) || (this.state === null && this.props.teamCalendar) ? 'none' : 'block' } }>
          {Object.keys(group.rows).map((key, j) => (
            this.renderRow(group.rows[key], j, dates)
          ))}
        </div>
      </div>
    )
  }
  renderGroupHeaderRow(group, i, dates) {
    const isHidden = (this.state && !this.state[group.id]) || (this.state === null && this.props.teamCalendar)
    return (
      <HeaderRowGroup style={ { height: 50, flex: '0 0 50', display: 'flex', flexDirection: 'row' } }>
        {
          get(this.props, 'teamCalendar') &&
          <CellLeftColGroup
            style={ { backgroundColor: '#FFFFFF', width: 200, overflow: 'hidden', cursor: 'pointer', borderRight: '1px solid #EAEAEA' } }
            onClick={ this.onGroupHeaderClick.bind(this, group) }
          >
            <b>{group.label} {isHidden ? <Icon src={ ArrowUp } alt='up' /> : <Icon src={ ArrowDown } alt='down' /> }</b>
          </CellLeftColGroup >
        }
        {/* {
          !this.props.teamCalendar &&
          <CellLeftCol style={ { backgroundColor: '#FFFFFF', width: 200, overflow: 'hidden' } }>
            <p>Date</p>
          </CellLeftCol>
        } */}
        <Cell style={ { flex: 1, backgroundColor: '#E7E7E7' } } />
      </HeaderRowGroup>
    )
  }

  renderRow(row, j, dates) {
    return (
      get(this.props, 'teamCalendar') ?
        <HeaderRow key={ j } style={ { height: 50, flex: '0 0 50', display: 'flex', flexDirection: 'row' } }>
          <CellLeftCol style={ { backgroundColor: '#FFFFFF', width: 200, overflow: 'hidden', borderRight: '1px solid #EAEAEA', fontSize: FONTS.SMALL_SIZE } }>{row.label}</CellLeftCol>
          <div style={ { flex: 1, overflow: 'hidden', display: 'flex' } }>
            {dates.map((date, k) => (
              this.renderCell(row, date, k)
            ))}
          </div>
        </HeaderRow>
        :
        <HeaderRow key={ j } style={ { flex: '0 0 50', display: 'flex', flexDirection: 'row' } }>
          <div style={ { backgroundColor: '#FFFFFF', width: 200, paddingBottom: '2%', height: '100%', overflow: 'hidden', borderRight: '1px solid #EAEAEA' } }>
            <Container>
              <Row style={ { height: 50, alignItems: 'center', paddingLeft: 10 } }>
                { get(this.props, 'myUser') &&
                  <IconCalendar>
                    {`${get(this.props, 'myUser.nick_name')} ${get(this.props, 'myUser.first_name')}`}
                  </IconCalendar>
                }
              </Row>
              <DropdownItem divider style={ { margin: 0 } } />
              <Row style={ { padding: 10 } }>
                <IconCalendar>Icon on calendar</IconCalendar>
              </Row>
              <Row style={ { padding: 3 } }>
                <Col><Compensate /></Col>
                <Col>Compensate</Col>
              </Row>
              <Row style={ { padding: 3 } }>
                <Col><Holiday /></Col>
                <Col>Holiday</Col>
              </Row>
              <Row style={ { padding: 3 } }>
                <Col><Approved /></Col>
                <Col>Approved</Col>
              </Row>
              <Row style={ { padding: 3 } }>
                <Col style={ { display: 'flex' } }>
                  <Pending /><PendingCompensate />
                </Col>
                <Col>Pending</Col>
              </Row>
            </Container>
          </div>
          <div style={ { height: 50, flex: 1, overflow: 'hidden', display: 'flex' } }>
            {dates.map((date, k) => (
              this.renderCell(row, date, k)
            ))}
          </div>
        </HeaderRow>

    )
  }

  renderCell(row, date, k) {
    const isWeekEnd = date.day() === 0 || date.day() === 6
    const holiday = this.isPublicHoliday(date)
    const isHoliday = holiday.isHoliday
    const data = row.map[moment(date).format('YYYY-MM-DD')]
    return (
      <Cell onClick={ data ? () => this.props.handleClickCell(false, data) : isHoliday ? () => this.props.handleClickCell(true, holiday.holiday) : () => {} } key={ k } style={ { cursor: data || isHoliday ? 'pointer' : '', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, overflow: 'hidden', backgroundColor: isHoliday ? '#7B7B7B' : isWeekEnd ? '#DDDDDD' : 'white' } }>
        { data && data.events.length === 2 && orderBy(data.events, ['leave_time'], 'asc').map((event, i) => {
          return event.content
        })}
        { data && data.events.length === 1 && data.events[0].content}
      </Cell>
    )
  }

  renderSummaryRow(dates) {
    return (
      <HeaderRowSum style={ { position: 'absolute', bottom: 0, right: 0, width: '100%', height: 50, display: 'flex', flexDirection: 'row' } }>
        <CellLeftCol style={ { backgroundColor: '#F7F7F7', width: 200, overflow: 'hidden' } }>Number of People</CellLeftCol>
        <div style={ { flex: 1, overflow: 'hidden', display: 'flex' } }>
          {dates.map((date, k) => (
            this.renderSummaryCell(date, k)
          ))}
        </div>
      </HeaderRowSum >
    )
  }

  renderSummaryCell(date, k) {
    // const isWeekEnd = date.day() === 0 || date.day() === 6
    return (
      <Cell key={ k } style={ { flex: 1, overflow: 'hidden', backgroundColor: '#F7F7F7', display: 'flex', alignItems: 'center', justifyContent: 'center' } }>
        {this.props.summary && this.props.summary.map[date.format('YYYY-MM-DD')] && this.props.summary.map[date.format('YYYY-MM-DD')].content}
        {this.props.summary && !this.props.summary.map[date.format('YYYY-MM-DD')] && this.props.summary.default}
      </Cell>
    )
  }

  renderDatesRow(dates) {
    return (
      <HeaderRowDate style={ { backgroundColor: '#FFFFFF', position: 'absolute', overflow: 'hidden', top: 0, right: 0, width: '100%', height: 50, display: 'flex', flexDirection: 'row' } }>
        <Date style={ { width: 200, paddingLeft: '2%', paddingTop: '1%' } }>Date</Date>
        <Cell style={ { backgroundColor: '#FFFFFF', flex: 1, overflow: 'hidden', display: 'flex', borderBottom: '2px' } }>
          {dates.map((date, k) => (
            this.renderDateCell(date, k)
          ))}
        </Cell>
      </HeaderRowDate>
    )
  }

  renderDateCell(date, k) {
    const isToday = date.isSame(moment(), 'day')
    return (
      <Cell key={ k } style={ { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderTopColor: '#ad191f', borderTopWidth: isToday ? 5 : 0 } }>
        <div style={ { color: isToday ? '#ad191f' : 'black', marginTop: isToday ? -5 : 0 } }>{date.format('dd')}</div>
        <div style={ { color: isToday ? '#ad191f' : 'black' } }>{date.date()}</div>
      </Cell>
    )
  }

  renderDummyRow() {
    return (
      <HeaderRow style={ { visibility: 'hidden', height: 80, flex: '0 0 50', display: 'flex', flexDirection: 'row' } } />
    )
  }

  render() {
    const dates = metrolendarHelper.getTableDates(this.props.moment, this.props.range)
    const groups = metrolendarHelper.generateMetrolendarEventsTableLookup(this.props.events)

    return (
      <TableContainer>
        {this.renderDatesRow(dates)}
        <DivCalendar>
          {Object.keys(groups).map((key, i) => (
            <Group
              range={ this.props.range }
              moment={ this.props.moment }
              search={ this.props.search }
              state={ this.state }
              lob={ key }
              renderGroup={ () => this.renderGroup(groups[key], i, dates) }
            />
          ))}
          <div>
            {this.renderDummyRow()}
          </div>
        </DivCalendar>
        <div>
          {this.props.teamCalendar && this.props.summary && this.renderSummaryRow(dates)}
        </div>
      </TableContainer>
    )
  }
}

const DivCalendar = styled.div`
  width: 100%;
  overflow-y: scroll;
  margin-top: 50px;
  max-height: calc(100vh - 175px);
  ::-webkit-scrollbar {
    display: none;
  }
  font-size: ${FONTS.SMALL_SIZE};  
`
const TableContainer = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  position: relative;
  width: 100%;
  height: calc(100vh - 130px);
  margin-top: 10px;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  border: solid #EAEAEA;
  border-width: 1px 0px 0px 1px; /* global top + left */
`
const HeaderRow = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 0px 1px 0px;
`
const HeaderRowDate = styled.div`
  border: solid #000000;
  border-width: 0px 0px 2px 0px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const Date = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const IconCalendar = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const HeaderRowGroup = styled.div`
  background-color: #FFFFFF;
  border: solid #EAEAEA;
  border-width: 0px 0px 1px 0px;
`
const HeaderRowSum = styled.div`
  border: solid #000000;
  border-width: 2px 0px 0px 0px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const Cell = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const CellLeftCol = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1% ;
`
const CellLeftColGroup = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
  display: flex;
  align-items: center;
  padding-left: 1% ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const Compensate = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #0071BD;
`
const Holiday = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #7B7B7B;
`
const Approved = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #333333;
`
const Pending = styled.div`
  width: 20px;
  height: 20px;
  border-style: solid;
  border-color: #FFD27C;
  border-radius: 50%;
  border-width: 2px;
`
const PendingCompensate = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 5px ;
  border-style: solid;
  border-color: #0071BD;
  border-radius: 50%;
  border-width: 2px;
`
const Icon = styled.img`
  width: 10px;
  height: 10px;
  margin-left: 10px;
`




// WEBPACK FOOTER //
// ./src/components/metrolendar/vertical-table/index.js